import { OUT_OF_NETWORK_INSURANCE_OPTION, UNINSURED_OPTION } from "./insurance";

export const AcknowledgedPolicyEnum = {
  CANCELLATION_POLICY_NAME: "cancellation_policy",
  CREDIT_CARD_AUTHORIZATION_POLICY_NAME: "credit_card_authorization_policy",
  OUT_OF_NETWORK_INSURANCE_POLICY_NAME: "out_of_network_insurance_policy",
  UNINSURED_POLICY_NAME: "uninsured_policy",
} as const;

export const ADVANCED_CARE_PROGRAM = "ADVANCED_CARE_PROGRAM";
export const CONSENT_TO_TREATMENT = "CONSENT_TO_TREATMENT";
export const HIPAA = "HIPAA";
export const PRIVACY = "PRIVACY";
export const TERMS_AND_CONDITIONS = "TERMS_AND_CONDITIONS";

export const ConsentedPolicyEnum = {
  ADVANCED_CARE_PROGRAM: "advanced_care_program",
  CONSENT_TO_TREATMENT: "treatment",
  HIPAA: "hipaa",
  PRIVACY: "privacy",
  TERMS_AND_CONDITIONS: "eula",
} as const;

export const CarrierToInsurancePolicyNameMap = {
  [OUT_OF_NETWORK_INSURANCE_OPTION]: AcknowledgedPolicyEnum.OUT_OF_NETWORK_INSURANCE_POLICY_NAME,
  [UNINSURED_OPTION]: AcknowledgedPolicyEnum.UNINSURED_POLICY_NAME,
} as const;
